<template>
<div class="forgot-password">
    <vue-headful
        title="TZ Design Box - Forgot Password"
        description="TZ Design Box"
    />
    <section class="section login">
        <div class="container">
            <div class="columns is-centered">
                <div class="column is-6 has-text-centered">
                    <h2 v-if="generic"><img v-show="site_logo" :src="site_logo" :alt="site_title" /><span v-show="! site_title_as_alt">{{ site_title }}</span></h2>
                    <p>{{ $t("enter-email") }}</p>
                    <br>
                    <form @submit.prevent="validateBeforeSubmit">
                        <b-field :label="$t('email')"
                            :type="{'is-danger': errors.has('email')}"
                            :message="errors.first('email')">
                            <b-input type="text" v-model="user.email" name="email" v-validate="'required|email'" />
                        </b-field>

                        <button type="submit" class="button is-primary"> {{ $t("reset-password") }} </button>
                    </form>
                </div>
            </div>
        </div>
    </section>
</div>
</template>

<script>
import { mapGetters } from 'vuex';
import config         from '@/config'

export default {
    name: 'UserForgotPassword',
    data: function(){
        return {
            user:{
                email: '',
            },
            generic: config.generic,
            site_title: config.title,
            site_logo: config.logo,
            site_title_as_alt: config.title_as_alt,
        }
    },
    methods: {
        validateBeforeSubmit() {
            var self=this;
            this.$validator.validateAll().then((result) => {
                if (result) {
                    this.$store.dispatch("forgotPassword",{user:this.user,self:self}).then(() => {

                    }).catch((error) =>{
                        this.$toastr('error', error, 'Failure');
                });
                    return;
                }
            });
        }
    },
}
</script>